import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue";
var _hoisted_1 = {
  class: "base-list-body"
};
var _hoisted_2 = {
  class: "top-body"
};
var _hoisted_3 = {
  class: "title-box"
};
var _hoisted_4 = {
  class: "title"
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "list-body"
};
var _hoisted_7 = {
  key: 0,
  class: "empty-body"
};
import { HelpCircleIcon } from 'tdesign-icons-vue-next';
export default {
  __name: 'BaseList',
  props: {
    title: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    },
    showMore: {
      type: Boolean,
      default: true
    },
    empty: {
      type: Boolean,
      default: true
    }
  },
  emits: ['change'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emit = __emit;
    var rightEnter = require('@/assets/home/double.svg');
    return function (_ctx, _cache) {
      var _component_t_tooltip = _resolveComponent("t-tooltip");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h5", _hoisted_4, _toDisplayString(__props.title), 1), _createVNode(_component_t_tooltip, {
        class: "placement top center",
        content: __props.tip,
        placement: "top",
        "overlay-style": {
          maxWidth: '260px'
        },
        "show-arrow": ""
      }, {
        default: _withCtx(function () {
          return [_createVNode(_unref(HelpCircleIcon), {
            class: "circle-icon"
          })];
        }),
        _: 1
      }, 8, ["content"])]), !__props.empty ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "right-box",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return emit('change');
        })
      }, [_cache[1] || (_cache[1] = _createElementVNode("span", null, "查看更多", -1)), _createElementVNode("img", {
        src: _unref(rightEnter),
        alt: ""
      }, null, 8, _hoisted_5)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [__props.empty ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_cache[2] || (_cache[2] = _createElementVNode("p", null, "暂无内容", -1)), _renderSlot(_ctx.$slots, "empty-footer")])) : _renderSlot(_ctx.$slots, "body", {}, undefined, undefined, 1)])]);
    };
  }
};